module.exports = __webpack_public_path__ + "static/media/magic-panda-resumen.4e933f98.png";